import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutcomesFormComponent } from './outcomes-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormTemplateModule } from '../form-template/form-template.module';
import { FormValidationMessageModule } from '../../form-validation-message/form-validation-message.module';

@NgModule({
  declarations: [OutcomesFormComponent],
  imports: [CommonModule, SharedModule, FormTemplateModule, FormValidationMessageModule],
  exports: [OutcomesFormComponent],
})
export class OutcomesFormModule {}
